import { Component, HostListener, OnInit } from "@angular/core";
import { FeaturesBaseComponent } from "../features-common/components/features-base.component";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import Swal from "sweetalert2";
import { LoginService } from "./services/login.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { APIUrl } from "../features-common/constants/APIUrls";
import { Router } from "@angular/router";
const helper = new JwtHelperService();
import { addBackToTop } from "vanilla-back-to-top";
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  translatetitle: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "./retailers",
    title: "Retailers",
    icon: "supervisor_account",
    class: "",
    translatetitle: "pages.sidebar.Retailers",
  },
  {
    path: "./consumers/all-consumers",
    title: "Consumers",
    icon: "manage_accounts",
    class: "",
    translatetitle: "Consumers",
  },
  {
    path: "./products",
    title: "Products",
    icon: "widgets",
    class: "",
    translatetitle: "pages.sidebar.Products",
  },
  {
    path: "./providers",
    title: "Providers",
    icon: "online_prediction",
    class: "",
    translatetitle: "pages.sidebar.Providers",
  },
  {
    path: "./manage-users",
    title: "Manage Users",
    icon: "manage_accounts",
    class: "",
    translatetitle: "pages.sidebar.ManageUsers",
  },
  {
    path: "./wallet",
    title: "Wallet",
    icon: "account_balance_wallet",
    class: "",
    translatetitle: "pages.sidebar.Wallet",
  },
  {
    path: "./reports/real-time-transactions",
    title: "Retailer Reports",
    icon: "stacked_bar_chart",
    class: "",
    translatetitle: "Retailer Reports",
  },
  {
    path: "./consumer-reports/real-time-transactions",
    title: "Consumer Reports",
    icon: "admin_panel_settings",
    class: "",
    translatetitle: "Consumer Reports",
  },
  // { path: './admin-nameId', title: 'Admin Name ID', icon: 'admin_panel_settings', class: '', translatetitle: 'pages.sidebar.AdminNameID' },
];
@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent extends FeaturesBaseComponent implements OnInit {
  sideMenu: any[];
  rememberMe: string;

  // Idle timeout variables decleration
  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  idleTimeInterval: number; // Idle check for every 5 min - 10 sec
  facebookUrl: any;
  instagramUrl: any;

  constructor(
    private loginService: LoginService,
    private idle: Idle,
    private keepalive: Keepalive,
    private router: Router
  ) {
    super();

    this.uiConfigValuesService
      .getUIConfigValues("FacebookURL")
      .subscribe((res) => {
        if (res["httpcode"] == 200) {
          this.facebookUrl = res.data;
        }
      });
    this.uiConfigValuesService
      .getUIConfigValues("InstagramURL")
      .subscribe((res) => {
        if (res["httpcode"] == 200) {
          this.instagramUrl = res.data;
        }
      });

    this.uiConfigValuesService
      .getIdleCheckValue("Ideal Time")
      .subscribe((res) => {
        if (res["httpcode"] == 200) {
          this.idleTimeInterval = Number(res.data);

          this.idle.setIdle(this.idleTimeInterval); // set idle time in sec
          //;
          this.idle.setTimeout(10); // set idle timeOut after idle time in sec
          this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        }
      });

    //On user gone idle
    idle.onIdleStart.subscribe(() => {
      this.idleState = `You've gone idle!`;
      // Swal.fire({
      //   title: this.idleState,
      //   position: 'top-end',
      //   showConfirmButton: false,
      //   timer: 1500
      // })
    });

    //On activity ie., user is not idle
    idle.onIdleEnd.subscribe(() => {
      this.idleState = "Is not idle.";

      // this.getRefreshToken()
      this.reset();
    });

    // On timeout warning
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = "You will time out in " + countdown + " seconds!";
      //Show timout timer if rememberMe is not Yes
      if (this.rememberMe == "No") {
        Swal.fire({
          title: `You've been idle!`,
          text: this.idleState,
          position: "top-end",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Stay",
          cancelButtonText: "Leave",
        }).then((result) => {
          // On Stay Clicked
          // Call refresh if isLoggedIn if not --> Logut
          if (result.isConfirmed) {
            this.isLoggedIn() ? this.getRefreshToken() : this.logOut();
          }
          // On Leave Clicked
          else if (result.dismiss === Swal.DismissReason.cancel) {
            this.logOut();
          }
        });
      }
    });

    // On timeout reached
    idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.timedOut = true;

      //;
      this.logOut();
    });

    // sets the ping interval to this.timer seconds
    keepalive.interval(this.idleTimeInterval);

    keepalive.onPing.subscribe(() => {
      this.lastPing = new Date();
    });

    if (this.isLoggedIn()) {
      idle.watch();

      this.timedOut = false;
    } else idle.stop();
  }

  setRefreshInerval(refreshInterval) {
    this.getRefreshToken();
    setInterval(() => {
      this.getRefreshToken();
    }, refreshInterval);
  }

  //GET refresh token
  getRefreshToken() {
    let url = APIUrl.getRefreshToken;
    this.httpService.get(url).subscribe((res) => {
      if (res["httpcode"] == 200) {
        let idToken = res["data"].jwt;
        localStorage.setItem("accessToken", idToken);
        this.idle.stop();
        this.reset();
      }
    });
  }

  // On reset
  reset() {
    this.idle.watch();
    this.idleState = "Started.";

    this.timedOut = false;
  }

  // On invalid token or expired user session
  logOut() {
    this.idle.stop();
    Swal.close();
    if (this.isLoggedIn()) {
      this.loginService.logout().subscribe(() => {
        localStorage.clear();
        this.router.navigateByUrl("login");
      });
      return;
    }
    localStorage.clear();
    this.router.navigateByUrl("login");
  }

  isLoggedIn(): boolean {
    let _token: string = localStorage.getItem("accessToken");
    if (_token == null || _token == undefined) {
      return false;
    }
    const isTokenExpired = helper.isTokenExpired(_token);
    if (!isTokenExpired) {
      return true;
    } else return false;
  }

  ngOnInit(): void {
    super.ngOnInit();
    addBackToTop();

    let _token: string = localStorage.getItem("accessToken");
    const decodedToken = helper.decodeToken(_token);
    if (decodedToken.role == "Sales Rep") {
      this.sideMenu = ROUTES.filter((item: any) => {
        return item.title !== "Consumer Reports" && item.title !== 'Consumers';
      });
    } else {
      this.sideMenu = ROUTES;
    }
    this.rememberMe = localStorage.getItem("isRemeberMe");
    let visited = localStorage.getItem("visited");
    if ((this.isLoggedIn() && visited == null) || visited == undefined) {
      // this.rxStompService.activate()

      this.loginService.getRefreshTimeOut().subscribe((res) => {
        if (res["httpcode"] == 200) {
          localStorage.setItem("visited", "yes");
          let refreshInterval: any = res["data"] * 1000; // refresh interval in ms
          // this.idleTimeInterval = res['data'] - 120 // 2min diff between idle time & refresh interval

          this.setRefreshInerval(refreshInterval);
        }
        // this.timer = 10; //set to 1min earlier
      });
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  // Event on browser refresh
  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    localStorage.removeItem("visited");
    event.returnValue = false;
  }
}
